import { render } from "./InputBlock.vue?vue&type=template&id=603b915a"
import script from "./InputBlock.vue?vue&type=script&lang=js"
export * from "./InputBlock.vue?vue&type=script&lang=js"
script.render = render

export default script